import React from 'react';
import theme from './SelectedCorner.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classnames } from '@/utils/html';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

interface SelectedCornerProps {
    visible?: boolean;
}

const SelectedCorner: React.FC<SelectedCornerProps> = ({ visible = true }) => {
    return (
        <div className={classnames(theme.corner, { [theme.hidden]: !visible })}>
            <span>
                <FontAwesomeIcon icon={faCheck} />
            </span>
        </div>
    );
};

export default SelectedCorner;
